
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/quickEditEngine/components/styles/genericComponentControl.scss.css.virtualfile';
        module.exports = {"quickEditGenericThumbnail":"_quickEditGenericThumbnail_4k2yg_7"};